// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1KeMJ","unreadBadge":"styles_unreadBadge__3Rxly","modalContent":"styles_modalContent__ddNeV","modal":"styles_modal__WqwhU"};